import React from "react";
import "./receiptPreviewContainerHeaderView.scss";
import close from "../../../assets/close.svg";
import printIcon from "../../../assets/print_icon.svg";
import downloadIcon from "../../../assets/DownloadIconGrey.svg";
import shareIcon from "../../../assets/shareFile.svg";
import whiteLoader from "../../../assets/whiteLoader.gif";

const ReceiptPreviewContainerHeaderView = (props) => {
  const {
    showShare,
    showLoader,
    handleShare,
    handlePrint,
    handleDownload,
    handleCloseRecipt,
  } = props;

  return (
    <div className="recipt-preview-header-container">
      {showShare ? (
        <img
          src={shareIcon}
          alt="#"
          className="rphc-icon"
          onClick={handleShare}
        />
      ) : showLoader ? (
        <img src={whiteLoader} alt="#" className="rphc-icon" />
      ) : null}
      <img
        src={printIcon}
        alt="#"
        onClick={handlePrint}
        className="rphc-icon"
      />
      <img
        src={downloadIcon}
        alt="#"
        onClick={handleDownload}
        className="rphc-icon"
      />
      <div className="recipt-preview-header-close" onClick={handleCloseRecipt}>
        <img src={close} alt="" />
      </div>
    </div>
  );
};

export default ReceiptPreviewContainerHeaderView;
